<template>
  <v-container>
    <o-main-progress v-if="!loadedAll"/>
    <v-card v-else>
      <Cabecera 
      tipoModuloActual="registro"
      :incrustado="true"/>
      <v-container fluid>
        <o-base-justify-text>
          <span v-html="getTexto('registro.bienvenida', codigoPromocion)"/>
        </o-base-justify-text>
        <o-big-title>{{$t('pages.incrustado.datosCliente')}}</o-big-title>
        <v-form ref="form" v-model="valid">
          <v-slide-x-transition mode="out-in">
          <div v-if="registrar" key="registro">
            <v-layout row wrap align-center justify-center style="position:relative;">
              <v-flex xs12 sm3 md2 lg2 xl1 px-2 pt-3 pb-1>
                <v-layout justify-center :justify-end="$vuetify.breakpoint.smAndUp">
                  <div :style="$vuetify.breakpoint.mdAndUp ? 'width:100px;' : ''">
                    <svg style="width:100%;height:100%;max-width:100px;max-height-100px;" class="primary--text mt-1 d-block" viewBox="0 0 55 55">
                      <g style="fill:currentColor;">
                        <path d="M55,27.5C55,12.337,42.663,0,27.5,0S0,12.337,0,27.5c0,8.009,3.444,15.228,8.926,20.258l-0.026,0.023l0.892,0.752  c0.058,0.049,0.121,0.089,0.179,0.137c0.474,0.393,0.965,0.766,1.465,1.127c0.162,0.117,0.324,0.234,0.489,0.348  c0.534,0.368,1.082,0.717,1.642,1.048c0.122,0.072,0.245,0.142,0.368,0.212c0.613,0.349,1.239,0.678,1.88,0.98  c0.047,0.022,0.095,0.042,0.142,0.064c2.089,0.971,4.319,1.684,6.651,2.105c0.061,0.011,0.122,0.022,0.184,0.033  c0.724,0.125,1.456,0.225,2.197,0.292c0.09,0.008,0.18,0.013,0.271,0.021C25.998,54.961,26.744,55,27.5,55  c0.749,0,1.488-0.039,2.222-0.098c0.093-0.008,0.186-0.013,0.279-0.021c0.735-0.067,1.461-0.164,2.178-0.287  c0.062-0.011,0.125-0.022,0.187-0.034c2.297-0.412,4.495-1.109,6.557-2.055c0.076-0.035,0.153-0.068,0.229-0.104  c0.617-0.29,1.22-0.603,1.811-0.936c0.147-0.083,0.293-0.167,0.439-0.253c0.538-0.317,1.067-0.648,1.581-1  c0.185-0.126,0.366-0.259,0.549-0.391c0.439-0.316,0.87-0.642,1.289-0.983c0.093-0.075,0.193-0.14,0.284-0.217l0.915-0.764  l-0.027-0.023C51.523,42.802,55,35.55,55,27.5z M2,27.5C2,13.439,13.439,2,27.5,2S53,13.439,53,27.5  c0,7.577-3.325,14.389-8.589,19.063c-0.294-0.203-0.59-0.385-0.893-0.537l-8.467-4.233c-0.76-0.38-1.232-1.144-1.232-1.993v-2.957  c0.196-0.242,0.403-0.516,0.617-0.817c1.096-1.548,1.975-3.27,2.616-5.123c1.267-0.602,2.085-1.864,2.085-3.289v-3.545  c0-0.867-0.318-1.708-0.887-2.369v-4.667c0.052-0.519,0.236-3.448-1.883-5.864C34.524,9.065,31.541,8,27.5,8  s-7.024,1.065-8.867,3.168c-2.119,2.416-1.935,5.345-1.883,5.864v4.667c-0.568,0.661-0.887,1.502-0.887,2.369v3.545  c0,1.101,0.494,2.128,1.34,2.821c0.81,3.173,2.477,5.575,3.093,6.389v2.894c0,0.816-0.445,1.566-1.162,1.958l-7.907,4.313  c-0.252,0.137-0.502,0.297-0.752,0.476C5.276,41.792,2,35.022,2,27.5z M42.459,48.132c-0.35,0.254-0.706,0.5-1.067,0.735  c-0.166,0.108-0.331,0.216-0.5,0.321c-0.472,0.292-0.952,0.57-1.442,0.83c-0.108,0.057-0.217,0.111-0.326,0.167  c-1.126,0.577-2.291,1.073-3.488,1.476c-0.042,0.014-0.084,0.029-0.127,0.043c-0.627,0.208-1.262,0.393-1.904,0.552  c-0.002,0-0.004,0.001-0.006,0.001c-0.648,0.16-1.304,0.293-1.964,0.402c-0.018,0.003-0.036,0.007-0.054,0.01  c-0.621,0.101-1.247,0.174-1.875,0.229c-0.111,0.01-0.222,0.017-0.334,0.025C28.751,52.97,28.127,53,27.5,53  c-0.634,0-1.266-0.031-1.895-0.078c-0.109-0.008-0.218-0.015-0.326-0.025c-0.634-0.056-1.265-0.131-1.89-0.233  c-0.028-0.005-0.056-0.01-0.084-0.015c-1.322-0.221-2.623-0.546-3.89-0.971c-0.039-0.013-0.079-0.027-0.118-0.04  c-0.629-0.214-1.251-0.451-1.862-0.713c-0.004-0.002-0.009-0.004-0.013-0.006c-0.578-0.249-1.145-0.525-1.705-0.816  c-0.073-0.038-0.147-0.074-0.219-0.113c-0.511-0.273-1.011-0.568-1.504-0.876c-0.146-0.092-0.291-0.185-0.435-0.279  c-0.454-0.297-0.902-0.606-1.338-0.933c-0.045-0.034-0.088-0.07-0.133-0.104c0.032-0.018,0.064-0.036,0.096-0.054l7.907-4.313  c1.36-0.742,2.205-2.165,2.205-3.714l-0.001-3.602l-0.23-0.278c-0.022-0.025-2.184-2.655-3.001-6.216l-0.091-0.396l-0.341-0.221  c-0.481-0.311-0.769-0.831-0.769-1.392v-3.545c0-0.465,0.197-0.898,0.557-1.223l0.33-0.298v-5.57l-0.009-0.131  c-0.003-0.024-0.298-2.429,1.396-4.36C21.583,10.837,24.061,10,27.5,10c3.426,0,5.896,0.83,7.346,2.466  c1.692,1.911,1.415,4.361,1.413,4.381l-0.009,5.701l0.33,0.298c0.359,0.324,0.557,0.758,0.557,1.223v3.545  c0,0.713-0.485,1.36-1.181,1.575l-0.497,0.153l-0.16,0.495c-0.59,1.833-1.43,3.526-2.496,5.032c-0.262,0.37-0.517,0.698-0.736,0.949  l-0.248,0.283V39.8c0,1.612,0.896,3.062,2.338,3.782l8.467,4.233c0.054,0.027,0.107,0.055,0.16,0.083  C42.677,47.979,42.567,48.054,42.459,48.132z"/>
                      </g> 
                    </svg>
                  </div>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm8 md5 lg4 xl3 px-3 pt-3 pb-1>
                <v-text-field
                  :label="$t('general.misc.nombre')"
                  :rules="[rules.required, rules.max(20)]"
                  v-model="nombre"
                />
                <v-text-field
                  :label="$t('general.misc.apellidos')"
                  :rules="[rules.required, rules.max(30)]"
                  v-model="apellidos"
                />
                <v-select
                  :items="getTiposDocumentos"
                  item-text="DESC_TIPO_DOCUMENTO_ID"
                  item-value="COD_TIPO_DOCUMENTO_ID"
                  :label="$t('comerciales.tipoDocumento')"
                  :rules="[rules.required]"
                  v-model="tipoDocumento"
                />
                <v-text-field
                  :label="$t('pages.incrustado.documento')"
                  :rules="[rules.required,rules.max(20), rules.validarNif(tipoDocumento)]"
                  :value="documento"
                  @input="documento = $event != null ? $event.toUpperCase() : $event"
                />
                <v-text-field
                  :label="$t('pages.incrustado.email')"
                  :rules="[rules.required,rules.email,rules.max(100)]"
                  v-model="usermail"
                />
                <v-text-field
                  :label="$t('pages.incrustado.contrasena')"
                  :rules="[rules.required, rules.noSoloEspacios, rules.min(8), rules.max(20)]"
                  v-model="password"
                  :type="mostrarPassword ? 'text' : 'password'"
                  :append-icon="!mostrarPassword ? 'visibility' : 'visibility_off'"
                  @click:append="mostrarPassword = !mostrarPassword"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center justify-center style="position:relative;">
              <v-flex xs12 sm11 md7 lg6 xl4 px-3 mb-4>
                <v-layout row wrap justify-end>
                  <v-btn @click="registrar = false" flat small class="titleColor--text" :disabled="waitingForLoad">{{$t('pages.incrustado.yaSoyUsuario')}}</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
          <div v-else key="login">
            <v-layout row wrap align-center justify-center style="position:relative;">
              <v-flex xs12 sm3 md2 lg2 xl1 px-2 pt-3 pb-1>
                <v-layout justify-center :justify-end="$vuetify.breakpoint.smAndUp">
                  <div :style="$vuetify.breakpoint.mdAndUp ? 'width:100px;' : ''">
                    <svg style="width:100%;height:100%;max-width:100px;max-height-100px;" class="primary--text mt-1 d-block" viewBox="0 0 55 55">
                      <g style="fill:currentColor;">
                        <path d="M55,27.5C55,12.337,42.663,0,27.5,0S0,12.337,0,27.5c0,8.009,3.444,15.228,8.926,20.258l-0.026,0.023l0.892,0.752  c0.058,0.049,0.121,0.089,0.179,0.137c0.474,0.393,0.965,0.766,1.465,1.127c0.162,0.117,0.324,0.234,0.489,0.348  c0.534,0.368,1.082,0.717,1.642,1.048c0.122,0.072,0.245,0.142,0.368,0.212c0.613,0.349,1.239,0.678,1.88,0.98  c0.047,0.022,0.095,0.042,0.142,0.064c2.089,0.971,4.319,1.684,6.651,2.105c0.061,0.011,0.122,0.022,0.184,0.033  c0.724,0.125,1.456,0.225,2.197,0.292c0.09,0.008,0.18,0.013,0.271,0.021C25.998,54.961,26.744,55,27.5,55  c0.749,0,1.488-0.039,2.222-0.098c0.093-0.008,0.186-0.013,0.279-0.021c0.735-0.067,1.461-0.164,2.178-0.287  c0.062-0.011,0.125-0.022,0.187-0.034c2.297-0.412,4.495-1.109,6.557-2.055c0.076-0.035,0.153-0.068,0.229-0.104  c0.617-0.29,1.22-0.603,1.811-0.936c0.147-0.083,0.293-0.167,0.439-0.253c0.538-0.317,1.067-0.648,1.581-1  c0.185-0.126,0.366-0.259,0.549-0.391c0.439-0.316,0.87-0.642,1.289-0.983c0.093-0.075,0.193-0.14,0.284-0.217l0.915-0.764  l-0.027-0.023C51.523,42.802,55,35.55,55,27.5z M2,27.5C2,13.439,13.439,2,27.5,2S53,13.439,53,27.5  c0,7.577-3.325,14.389-8.589,19.063c-0.294-0.203-0.59-0.385-0.893-0.537l-8.467-4.233c-0.76-0.38-1.232-1.144-1.232-1.993v-2.957  c0.196-0.242,0.403-0.516,0.617-0.817c1.096-1.548,1.975-3.27,2.616-5.123c1.267-0.602,2.085-1.864,2.085-3.289v-3.545  c0-0.867-0.318-1.708-0.887-2.369v-4.667c0.052-0.519,0.236-3.448-1.883-5.864C34.524,9.065,31.541,8,27.5,8  s-7.024,1.065-8.867,3.168c-2.119,2.416-1.935,5.345-1.883,5.864v4.667c-0.568,0.661-0.887,1.502-0.887,2.369v3.545  c0,1.101,0.494,2.128,1.34,2.821c0.81,3.173,2.477,5.575,3.093,6.389v2.894c0,0.816-0.445,1.566-1.162,1.958l-7.907,4.313  c-0.252,0.137-0.502,0.297-0.752,0.476C5.276,41.792,2,35.022,2,27.5z M42.459,48.132c-0.35,0.254-0.706,0.5-1.067,0.735  c-0.166,0.108-0.331,0.216-0.5,0.321c-0.472,0.292-0.952,0.57-1.442,0.83c-0.108,0.057-0.217,0.111-0.326,0.167  c-1.126,0.577-2.291,1.073-3.488,1.476c-0.042,0.014-0.084,0.029-0.127,0.043c-0.627,0.208-1.262,0.393-1.904,0.552  c-0.002,0-0.004,0.001-0.006,0.001c-0.648,0.16-1.304,0.293-1.964,0.402c-0.018,0.003-0.036,0.007-0.054,0.01  c-0.621,0.101-1.247,0.174-1.875,0.229c-0.111,0.01-0.222,0.017-0.334,0.025C28.751,52.97,28.127,53,27.5,53  c-0.634,0-1.266-0.031-1.895-0.078c-0.109-0.008-0.218-0.015-0.326-0.025c-0.634-0.056-1.265-0.131-1.89-0.233  c-0.028-0.005-0.056-0.01-0.084-0.015c-1.322-0.221-2.623-0.546-3.89-0.971c-0.039-0.013-0.079-0.027-0.118-0.04  c-0.629-0.214-1.251-0.451-1.862-0.713c-0.004-0.002-0.009-0.004-0.013-0.006c-0.578-0.249-1.145-0.525-1.705-0.816  c-0.073-0.038-0.147-0.074-0.219-0.113c-0.511-0.273-1.011-0.568-1.504-0.876c-0.146-0.092-0.291-0.185-0.435-0.279  c-0.454-0.297-0.902-0.606-1.338-0.933c-0.045-0.034-0.088-0.07-0.133-0.104c0.032-0.018,0.064-0.036,0.096-0.054l7.907-4.313  c1.36-0.742,2.205-2.165,2.205-3.714l-0.001-3.602l-0.23-0.278c-0.022-0.025-2.184-2.655-3.001-6.216l-0.091-0.396l-0.341-0.221  c-0.481-0.311-0.769-0.831-0.769-1.392v-3.545c0-0.465,0.197-0.898,0.557-1.223l0.33-0.298v-5.57l-0.009-0.131  c-0.003-0.024-0.298-2.429,1.396-4.36C21.583,10.837,24.061,10,27.5,10c3.426,0,5.896,0.83,7.346,2.466  c1.692,1.911,1.415,4.361,1.413,4.381l-0.009,5.701l0.33,0.298c0.359,0.324,0.557,0.758,0.557,1.223v3.545  c0,0.713-0.485,1.36-1.181,1.575l-0.497,0.153l-0.16,0.495c-0.59,1.833-1.43,3.526-2.496,5.032c-0.262,0.37-0.517,0.698-0.736,0.949  l-0.248,0.283V39.8c0,1.612,0.896,3.062,2.338,3.782l8.467,4.233c0.054,0.027,0.107,0.055,0.16,0.083  C42.677,47.979,42.567,48.054,42.459,48.132z"/>
                      </g> 
                    </svg>
                  </div>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm8 md5 lg4 xl3 px-3 pt-3 pb-1>
                <v-text-field
                  :label="$t('pages.incrustado.email')"
                  :rules="[rules.required,rules.email,rules.max(100)]"
                  v-model="usermail"
                />
                <v-text-field
                  :label="$t('pages.incrustado.contrasena')"
                  :rules="[rules.required, rules.noSoloEspacios, rules.max(20)]"
                  v-model="password"
                  :type="mostrarPassword ? 'text' : 'password'"
                  :append-icon="!mostrarPassword ? 'visibility' : 'visibility_off'"
                  @click:append="mostrarPassword = !mostrarPassword"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center justify-center style="position:relative;">
              <v-flex xs12 sm11 md7 lg6 xl4 px-3>
                <v-layout row wrap justify-end>
                  <v-btn @click="resetPassword()" flat small class="titleColor--text" :disabled="waitingForLoad">{{$t('pages.incrustado.olvidoContrasena')}}</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center justify-center style="position:relative;">
              <v-flex xs12 sm11 md7 lg6 xl4 px-3 mb-4>
                <v-layout row wrap justify-end>
                  <v-btn @click="registrar = true" flat small class="titleColor--text" :disabled="waitingForLoad">{{$t('pages.incrustado.registrarse')}}</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
          </v-slide-x-transition>
          <o-medium-title>{{$t('pages.incrustado.politicaPrivacidad')}}</o-medium-title>
          <v-layout>
            <v-flex xs12>
              <v-card>
                <v-container style="max-height:400px; overflow: auto;">
                  <o-base-justify-text :marginBottom="false">
                    {{politicaPrivacidad}}
                  </o-base-justify-text>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
          <v-checkbox
            color="primary"
            :label="$t('pages.incrustado.aceptoPoliticaPrivacidad')"
            :rules="[rules.checkboxSelected]"
            hide-details
            v-model="aceptado"
          />
        </v-form>
        <v-layout justify-center>
          <v-flex xs4>
            <v-layout justify-center>
              <v-btn 
                large
                color="primary"
                :disabled="waitingForLoad"
                :loading="waitingForLoad"
                @click="aceptar"
              >
                {{$t('pages.incrustado.aceptar')}}
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-fade-transition>
      <custom-dialog v-if="mostrarResetPassword" v-model="mostrarResetPassword">
        <PopUpResetPassword :usermailProp="usermail"/>
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog v-if="mostrarConfirmacion" v-model="mostrarConfirmacion" :noCerrar="noCerrarConfirmacion">
        <PopUpConfirmacion :incrustado="true"/>
      </custom-dialog>
    </v-fade-transition>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import rules from '@/mixins/rules'
import PopUpResetPassword from '@/components/incrustado/PopUpResetPassword'
import PopUpConfirmacion from '@/components/generic/PopUpConfirmacion'
import {incrustado} from '@/mixins/incrustado'
import Cabecera from '@/components/Cabecera'

export default {
  mixins: [rules, incrustado],
  data () {
    return {
      aceptado: false,
      waitingForLoad: false,
      usermail: '',
      nombre: '',
      apellidos: '',
      password: '',
      valid: false,
      mostrarResetPassword: false,
      mostrarConfirmacion: false,
      noCerrarConfirmacion: false,
      tipoDocumento: null,
      documento: null,
      confirmado: false,
      mostrarPassword: false,
      registrar: true
    }
  },
  components: {
    PopUpResetPassword,
    PopUpConfirmacion,
    Cabecera
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  computed: {
    ...mapGetters({
      alquiler: 'incrustado/alquiler',
      codigoPromocion: 'incrustado/codigoPromocion',
      promocion: 'promociones/getActual',
      codigoActivo: 'incrustado/codigoActivo',
      numOportunidad: 'incrustado/numOportunidad',
      usuarioComercial: 'incrustado/usuarioComercial',
      datosContacto: 'incrustado/datosContacto',
      politicaPrivacidadStore: 'configuracion/politicaPrivacidad/get',
      getTiposDocumentos: 'maestros/tiposDocumentos/getAll',
      scoring: 'scoring/get',
      reserva: 'reservas/_id/getActual',
      codSubdominioAgrupacion: 'login/codSubdominioAgrupacion'
    }),
    politicaPrivacidad () {
      return this.politicaPrivacidadStore
        .replace('#SOCIPROPNOMBRE', this.promocion.sociedadVendedora != null ? this.promocion.sociedadVendedora : '')
        .replace('#SOCIPROPCIF', this.promocion.sociedadVendedoraCIF != null ? this.promocion.sociedadVendedoraCIF : '')
        .replace('#SOCIPROPDIRECCION', this.promocion.sociedadVendedoraDireccion != null ? this.promocion.sociedadVendedoraDireccion : '')
        .replace('#SOCIGESTNOMBRE', this.promocion.sociedadGestora != null ? this.promocion.sociedadGestora : '')
        .replace('#SOCIGESTCIF', this.promocion.sociedadGestoraCIF != null ? this.promocion.sociedadGestoraCIF : '')
        .replace('#SOCIGESTDIRECCION', this.promocion.sociedadGestoraDireccion != null ? this.promocion.sociedadGestoraDireccion : '')
    },
    objetoParaApi () {
      return {
        codigoPromocion: this.codigoPromocion,
        codigoActivo: this.codigoActivo,
        simplificada: false,
        numOportunidad: this.numOportunidad,
        alquiler: this.alquiler,
        compradoresScoring: this.scoring.compradores !== undefined ? this.scoring.compradores : null,
        usuarioComercial: this.usuarioComercial != null ? this.usuarioComercial : null,
        compradorTitular: this.datosContacto == null ? 
        {
          conDatosContacto: false,
          nombre: this.nombre,
          apellidos: this.apellidos,
          email: this.usermail,
          tipoDocumentoID: this.tipoDocumento,
          nif: this.documento
        } :
        {
          conDatosContacto: true,
          nombre: this.nombre,
          apellidos: this.apellidos,
          email: this.usermail,
          tipoDocumentoID: this.tipoDocumento,
          nif: this.documento,
          tipoPersona: this.datosContacto.tipoPersona,
          fechaNacimiento: this.datosContacto.fechaNacimiento,
          sexo: this.datosContacto.sexo,
          estadoCivil: this.datosContacto.estadoCivil,
          nacionalidad: this.datosContacto.nacionalidad,
          sigla: this.datosContacto.sigla,
          domicilio: this.datosContacto.domicilio,
          numero: this.datosContacto.numero,
          escalera: this.datosContacto.escalera,
          piso: this.datosContacto.piso,
          puerta: this.datosContacto.puerta,
          pais: this.datosContacto.pais,
          provincia: this.datosContacto.provincia,
          poblacion: this.datosContacto.poblacion,
          codigoPostal: this.datosContacto.codigoPostal,
          telefono: this.datosContacto.telefono,
          telefono2: this.datosContacto.telefono2,
          movil: this.datosContacto.movil,
          fax: this.datosContacto.fax,
          proteccionDatos: this.datosContacto.proteccionDatos
        }
      }
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      registro: 'login/registro',
      logInIncrustado: 'login/logInIncrustado',
      crearReserva: 'reservas/_id/crear',
      loadPoliticaPrivacidad: 'configuracion/politicaPrivacidad/load',
      loadTiposDocumentos: 'maestros/loadTiposDocumentos',
      loadReserva: 'reservas/_id/load'
    }),
    async initialize () {
      try {
        await Promise.all([
          this.loadPoliticaPrivacidad(),
          this.loadTiposDocumentos()
        ])
        if (this.datosContacto != null) {
          this.usermail = this.datosContacto.email ? this.datosContacto.email : null
          this.nombre = this.datosContacto.nombre ? this.datosContacto.nombre : null
          this.apellidos = this.datosContacto.apellidos ? this.datosContacto.apellidos : null
          // C=C, N=N, P=P, T=T, Y=O.
          if (['C', 'N', 'P', 'T', 'Y'].includes(this.datosContacto.tipoDocumento) && this.getTiposDocumentos.find(x => x.COD_TIPO_DOCUMENTO_ID == this.datosContacto.tipoDocumento) != null) {
            this.tipoDocumento = this.datosContacto.tipoDocumento ? this.datosContacto.tipoDocumento : null
          }
          if (this.datosContacto.tipoPersona == 'J' && this.getTiposDocumentos.find(x => x.COD_TIPO_DOCUMENTO_ID == 'C') != null) {
            this.tipoDocumento = 'C'
          }
          this.documento = this.datosContacto.documento ? this.datosContacto.documento : null
        }
        return true
      } catch (error) {
        this.$router.push({name: 'incrustado.mensajeError'})
        return false
      }
    },
    async aceptar () {
      let logging = true
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      try {
        this.waitingForLoad = true
        if (this.registrar) {
          await this.registro({
            usermail: this.usermail,
            nombre: this.nombre,
            apellidos: this.apellidos,
            password: this.password,
            tipoDocumento: this.tipoDocumento,
            documento: this.documento,
            cod_subdominio_agrupacion: this.codSubdominioAgrupacion,
            cod_promocion: this.codigoPromocion.toString()
          })
        } else {
           await this.logInIncrustado({
            usermail: this.usermail,
            password: this.password
          })
        }
        logging = false
        await this.crearReserva(this.objetoParaApi)
        await this.loadReserva(this.reserva.id)
        if (this.reserva.actorConfirmacion == null || this.reserva.actorConfirmacion.token != null) {
          this.mostrarConfirmacion = true
          this.noCerrarConfirmacion = true
        } else {
          this.$router.push({name: 'incrustado.stepper'})
        }
        this.waitingForLoad = false
      } catch (error) {
        console.log(error)
        this.waitingForLoad = false
        switch (error.code) {
          case 10:
            this.$router.push({name: 'incrustado.mensajeReservado', params: {reservaUsuario: false}})
            break
          case 11:
            this.$router.push({name: 'incrustado.mensajeReservado', params: {reservaUsuario: true}})
            break
          case 13:
          case 20:
            this.addAlert({texto: error.message, color: 'error'})
            break
          default:
            this.addAlert({texto: error.message, color: 'error'})
            if (!logging) {
              this.$router.push({name: 'incrustado.mensajeError'})
            }
            break
        }
      }
    },
    resetPassword () {
      this.mostrarResetPassword = true
    },
    alertPreRefresh (e) {
      let message = this.$t('general.misc.alertPreRefresh')
      e = e || window.event
      // For IE and Firefox prior to version 4
      if (e) {
        e.returnValue = message
      }
      // For Safari
      return message
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/incrustado/registro.vue